import { 
  CompanyDetails, 
  BuildingDetails, 
  RepresentativesDetails, 
  ShareholdersDetails, 
  BeneficiariesDetails,
  ExecutionPlace,
  TechnicalCharacteristics,
} from './components';

export const tabs = () => {
  return [
    {
      label: `1.1 Βασικά Στοιχεία Επιχείρησης`,
      id: 0,
      Component: CompanyDetails,
    },
    {
      label: `1.2 Στοιχεία Ταυτότητας Εκπροσώπων`,
      id: 1,
      Component: RepresentativesDetails,
    },
    {
      label: `1.3 Στοιχεία Δικαιούχου / Κτιρίου`,
      id: 2,
      Component: BuildingDetails,
    },
  ].filter(item => item);
};
